import React from 'react';
import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import Input from '../../input/Input';
import InputNumber from '../../input/InputNumber';
import { setTrim } from '../../../lib/common';
import CountLabel from '../../CountLabel';

const InputForm = (props) => {
  const {
    form,
    label,
    rules,
    name,
    onChange,
    initialValue,
    type = 'string',
    subContent,
    className,
    withCount,
    maxLength,
    isEditable,
    getValueFromEvent,
    showInfo = true,
    isTrim = true,
    vertical = false,
    disabled = false,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  return (
    <div className={className}>
      <Form.Item
        className={cx('input-form', 'amondz-form', { 'with-label': label }, { vertical })}
        label={
          isEditable && withCount ? (
            <CountLabel
              content={form.getFieldValue(name) || initialValue}
              label={label}
              maxLength={maxLength}
              vertical={vertical}
            />
          ) : (
            label
          )
        }
      >
        {getFieldDecorator(name, {
          rules,
          type,
          initialValue,
          getValueFromEvent,
          onChange: (value) => {
            onChange && onChange(isTrim && type !== 'number' ? setTrim(value) : value);
          },
        })(
          type === 'number' ? (
            <InputNumber isEditable={isEditable} disabled={disabled} {...res} />
          ) : (
            <Input type={type} isEditable={isEditable} disabled={disabled} maxLength={maxLength} {...res} />
          ),
        )}
      </Form.Item>

      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
};

export default InputForm;
